import { createModelStore } from '@/shared/stores/create-model-store'
import { model2_2InitialModel } from './initial-state'
import { model2_2DimensionHandlers } from './dimensions'

export const useModel2_2Store = createModelStore({
  initialModel: model2_2InitialModel,
  dimensionHandlers: model2_2DimensionHandlers,
})
